import React, { useState } from 'react';
import { APIEndpoint ,DFPAPIEndpoint} from "../../../utils/axios";
import uploadItemIcon from '../../../assets/icons/upload-items.svg';
import { DataGrid, EditModal, UploadModal } from "../../../common";
import { getCultureFromLs, onDownloadXlsFile } from '../../../utils/commonFunctions';
import { useTranslation } from 'react-i18next';
import Edit2 from "../../../assets/edit2.svg";
import DOWNLOAD_ICON from "../../../assets/icons/download-master.svg";
import LoadingGIF from '../../../assets/loadingIn.gif';
import usePermissions from '../../../utils/userPermissions';

const Columns = [
  { field: 'code', headerName: 'Distributor Code',tooltipField:'code',flex:1, suppressSizeToFit:true, resizable:true,minWidth: 160 },
  { field: 'name', headerName: 'Name 1',flex:1,suppressSizeToFit:true, resizable:true,minWidth: 155,tooltipField: 'name',  cellStyle: {
    whiteSpace: 'nowrap',
    overflow:'hidden',
    textOverflow:'ellipsis',
  },},
  { field: 'name2', headerName: 'Name 2',flex:1,suppressSizeToFit:true, resizable:true,minWidth: 165,tooltipField: 'name2', cellStyle: {
    whiteSpace: 'nowrap',
    overflow:'hidden',
    textOverflow:'ellipsis',
  },},
  { field: 'mobile', headerName: 'Mobile', flex:1,suppressSizeToFit:true, resizable:true,minWidth: 130, filter: true },
  { field: 'email', headerName: 'Email',flex:1, tooltipField:'email',suppressSizeToFit:true, resizable:true, minWidth: 195, cellStyle: {
    whiteSpace: 'nowrap',
    overflow:'hidden',
    textOverflow:'ellipsis',
  }, },
  { field: 'address', headerName: 'Address',tooltipField:'address',flex:1, suppressSizeToFit:true, resizable:true, minWidth: 195,cellStyle: {
    whiteSpace: 'nowrap',
    overflow:'hidden',
    textOverflow:'ellipsis',
  },},
  { field: 'gstin', headerName: 'GSTIN',flex:1,tooltipField:'gstin', suppressSizeToFit:true, resizable:true, minWidth: 165,cellStyle: {
    whiteSpace: 'nowrap',
    overflow:'hidden',
    textOverflow:'ellipsis',
  },},
  // { field: '', headerName: '',filter: true},
];
const AddFormField = [
  { label: 'Name 1',placeholder:'Distributor Name 1',attribute: 'name', type: 'text', required: true, },
  { label: 'Name 2', placeholder:'Distributor Name 2', attribute: 'name2', type: 'text', required: true },
  { label: 'Distributor Code', attribute: 'code', type: 'text', required: true },
  { label: 'Email', placeholder:'Email Address', attribute: 'email', type: 'email', required: true },
  { label: 'Mobile',  placeholder:'Mobile Number',attribute: 'mobile', type: 'text' },
  { label: 'PAN',placeholder:'Distributor PAN Number', attribute: 'pan', type: 'text', required: true },
  { label: 'GSTIN',Placeholder:'Distributor GSTIN Number', attribute: 'gstin', type: 'text', required: true },
  { label: 'Address',  placeholder:'Address',attribute: 'address', type: 'textarea',rows:4 },
  { label: 'Street 1', attribute: 'street1', type: 'text', },
  { label: 'Street 2', attribute: 'street2', type: 'text', },
  { label: 'Street 3', attribute: 'street3', type: 'text', },
  { label: 'Postal Code', attribute: 'postalCode', type: 'text', required: true, },
  { label: 'City', attribute: 'city', type: 'text', required: true, },
  { label: 'State', attribute: 'stateCode', type: 'select', required: true, options: [] },
  { label: 'Country', attribute: 'country', type: 'text', required: true, disabled: true, initialValue: '' },
]

export const DistributorPage = (props) => {
  const [state, setState] = useState({})
  const { t,ready } = useTranslation();
  const [countryDetails,setCountryDetails]=useState({});
  const [statesIN, setStatesIN] = useState([]);
  const [modalFormStatusObj, setModalFormStatusObj] = useState({ text: '' });
  const [isDownloading, setIsDownloading] = useState(false);
  const [ uploadedFile, setUploadedFile ] = useState([])
  const [ uploadFileStatusBlock, setUploadFileStatusBlock ] = useState('');
  const { hasPermission: createBpa } = usePermissions('create', "orn:Account:ManageDistributorMaster");
  const { hasPermission: editBpa } = usePermissions('edit', "orn:Account:ManageDistributorMaster");
  const { hasPermission: uploadBpa } = usePermissions('upload', "orn:Account:ManageDistributorMaster");
  const { hasPermission: downloadBpa } = usePermissions('download', "orn:Account:ManageDistributorMaster");

  const sType = localStorage.getItem('sType');
  const DOMAIN = (sType === 'dfp' ? DFPAPIEndpoint : APIEndpoint);

  React.useEffect(() => {
   const  fetchCountryData=async()=>{
    try {
      const res = getCultureFromLs()
      if (res) {
        setCountryDetails(res);
      }
    } catch (error) {
      console.error('Error fetching country data:', error);
    }
    }
    fetchCountryData();
  }, []);

  React.useEffect(() => {
if(Object.keys(countryDetails).length){
  const statesMod = countryDetails.stateCodes.map((obj, index) => ({
    key: index + 1,
    label: obj.name,
    value: obj.code,
  }));
  setStatesIN(statesMod);

}
  }, [countryDetails]);

  const filterData = {
    action: 4,
    collection: '',
    filterOperation: 'or',
    filters: [],
    limit: 50,
    page: 1,
    searchParam: ''
  };
  const fetchDistributors = async (iPageNo = 1, iPageLimit = 50, iSearchText = '') => {
    filterData.page = iPageNo;
    filterData.limit = iPageLimit;
    filterData.searchParam = iSearchText;
    const res = await APIEndpoint.post('distributors/process', filterData);
    return res;
  }
  const handleModalClose = () => {
    setModalFormStatusObj({text:''})
    setState((_) => {
      return { ..._, showAddForm: false, editRow: null }
    })
  }
  const handleAddDistributor = () => {
    setState((_) => {
      return { ..._, showAddForm: createBpa?true :false}
    })
  }
  const handleReset = () => {
    setState((_) => {
      return { ..._, resetDataSource: true, showAddForm: false, editRow: null };
    })
    let timerId = setTimeout(() => {
      clearTimeout(timerId);
      setState((_) => {
        return { ..._, resetDataSource: false };
      })
    }, 500)
  }
  const handleAddDistributorSubmit = async (e, values) => {
    let isValid = true;
    if (values != null) {
      isValid = AddFormField.every(((field) => {
        if (
          field.required && (
            (Boolean(state.editRow) && !(values[field.attribute] || state.editRow[field.attribute])) ||
            (!Boolean(state.editRow) && !values[field.attribute] && field.attribute !== 'country')
          )
        ) {
          return false;
        }
        return true
      }));
      if (isValid) {
        const {countryCode}=countryDetails
        values.country =countryCode ;
        try {
          let res;
          if (Boolean(state.editRow)) {
            values = { ...state.editRow, ...values };
            res = await APIEndpoint.post('distributors/update/' + state.editRow.id, values);
          } else {
            res = await APIEndpoint.post('distributors/new', values);
          }
          if (res.success) {
            handleReset()
          }
          alert(res.msg);
        } catch (error) {
          // alert(error.data.msg);
          let {data}=JSON.parse(error.message);
          setModalFormStatusObj({error:data.msg})
        }
      }
    }
  }
  const handleRowAction = async (e, action, row) => {
    try {
      const res = await APIEndpoint.get('distributors/' + row.itemId);
      setState((_) => {
        return { ..._, editRow: res.result }
      })
    } catch (error) {
      alert(error.data.msg);
    }
  }

  const onDownloadSampleFile = async (e) => {
    onDownloadXlsFile('samples/downloads/Distributor_Master_Upload_Sample', 'Distributor_Master_Upload_Sample')
  }

  const onUploadClose = () => {
    setUploadedFile([]);
    setUploadFileStatusBlock('');
    setState((_) => ({ ..._, showUpload: false }))
  };

  const onUploadFileChangeHandler = async (e) => {
    const file=e.target.files[0];
    setUploadedFile(e.target.files[0]);
    setUploadFileStatusBlock('<p>Please wait while we process your data...</p>');

    const formData = new FormData();
    formData.append('scheduleLater', false);
    formData.append('listName', undefined);
    formData.append('targetSectorType', undefined);
    formData.append('stores', []);
    formData.append('warehouses', []);
    formData.append('file', file);

    try {
      await DOMAIN.post('distributors/master/upload', formData);
      setUploadFileStatusBlock('<p>File Imported Successfully.</p>');
      setState( (_prev) => {
        return { ..._prev,resetDataSource:true}
      });
      setUploadedFile([]);
    }
    catch(error) {
      e.target.value = null;
      setUploadedFile([]);
      let { status, data } = JSON.parse( error.message );
      let msgHeading = data?.Error || data?.message || error.message;
      msgHeading= msgHeading.includes('status')?`Failed to upload.`:msgHeading;

      let msgContent = "";
      if (status === 400 && data.errors) {
            data.errors.forEach( _ => {
            const lineNum = _.lineNumber;
            const errorMsgArr = [];
            _.errors.forEach(erObj => {
              errorMsgArr.push( erObj.field + ' | ' + erObj.message + ' \n<br>' );
            });

            msgContent += '<br>Line ' + lineNum + ': \n<br>' + errorMsgArr.join(' ');
        });
      } else if(status===0 && !data){
        msgContent += `Error occurred while uploading Distributors!<br>Please try again.`;
    }
    else if(status === 400 && data && data?.Error){
      msgHeading = data?.Error;
      msgContent += `Error occurred while uploading Distributors sheet!<br>Please try again.`;
    }
      else {
        msgContent += `Error occurred while uploading Distributors!<br>Please fix the errors and re-upload.`;
      }

      setUploadFileStatusBlock("<p class='listErrorMessagesCls'>"+ msgHeading + "</p>" +
                                "<p class='listErrorMessagesCls sm-scrollbar border p-2 pt-1'>" + msgContent +"</p>"
                              );
    }
};

  const onDownloadDistributors=async()=>{
    let header={
      'Accept':'text/csv'
    }
    try {
      setIsDownloading(true)
    const res= await APIEndpoint.post(`downloads/distributorMaster`,{reportType: "Distributors"},header);
    if(res.status==='scheduled'){
      setTimeout(() => {
        const dowId = APIEndpoint.get(`downloads/status/${res.id}`);
        dowId.then( async (val)=> {
          if(val.status==="completed"){
           await APIEndpoint.get(`downloads/analytics/${val.fileName}${val.fileExtension}`).then((ItemMasterDwnld) => {
              const url = window.URL.createObjectURL(new Blob([ItemMasterDwnld]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', val.fileName+'.csv'); //or any other extension
              document.body.appendChild(link);
              link.click();
              setIsDownloading(false)
          });

          }
        })
        }, 4000);
    }
    }
      catch (res) {
        console.log(res.message)
        setIsDownloading(false)
      }
  }

  function handleChange(e,updated) {
    setModalFormStatusObj({text:""})
  }

  return (
    <div className="op-aircraft-container flexCol full-flex ag-theme-alpine-dark">
      <DataGrid
        columnResize
        showDefaultFilters
        className='full-flex'
        columns={Columns}
        getRows={fetchDistributors}
        pageType={false}
        resetDataSource={state.resetDataSource}
              RightComponent={() => {
                  return ( uploadBpa || downloadBpa) ? (
                      <div className='flexRow width100 margTop8 justifyContentFlexEnd'>
          <div className="margLeft flexRow justifyContentFlexEnd alignItemsBaseline">
          {uploadBpa?<button title={t('pages.pagesContent.distributors.uploadBtn')} className='upload dropdownStyle1-TextMedium'  onClick={() => setState((_) => ({ ..._, showUpload: true }))}> <span><img  className="icon-size-min" alt='uploadItem' src={uploadItemIcon} /></span></button>:<></>}&nbsp;
              {downloadBpa? <div className="flexRow justifyContentFlexStart margRight">

                      {isDownloading ? (
                               <button className="margRight">
                                    <img
                                      src={LoadingGIF}
                                      className="margBottom0 icon-size-min"
                                      alt="Loading"
                                    />
                                  </button>
                              ) : (

                                  <button
                                    disabled={isDownloading}
                                    className="margRight"
                                    style={{ cursor: 'pointer' }}
                                    title={t('filters.downloadDistributor')}
                                    onClick={onDownloadDistributors}
                                  >
                                    <img src={DOWNLOAD_ICON} className="node-icon svg" alt="" />
                                  </button>
                                )
                              }

          </div>:<></>}

          </div>
        </div>
                  ) : null;
                }}
        addButton={{
          title: t('pages.pagesContent.distributors.addButtonTitle'),
          onClick: handleAddDistributor
        }}
        actions={[
          { detail: editBpa?[{ src: Edit2, value: "edit",title:"Edit" }]:[] }
        ]}
        onAction={handleRowAction}


      />
      {
        Boolean(state.showAddForm || state.editRow) &&
        <EditModal
          title={t('pages.pagesContent.distributors.' + (Boolean(state.editRow) ? 'editModalTitle' : 'addModalTitle'))}
          onClose={handleModalClose}
          onSubmit={handleAddDistributorSubmit}
          showFieldsInColumn={true}
          buttonLabel={'Save'}
          modalFormStatusObj={modalFormStatusObj}
          onChange={handleChange}
          fields={AddFormField.map((elt) => {
            let initialValue = '';
              if (state.editRow) {
                initialValue = state.editRow[elt.attribute] ?? '';
              } else if (elt.attribute === 'country') {
                initialValue = countryDetails?.countryCode || '';
              } else {
                initialValue = elt.initialValue || '';
              }
            return {
              ...elt,
              disabled:Boolean(state.editRow)?true:elt.attribute==='country'?true:false,
              initialValue,
              options: elt.attribute === 'stateCode' ? [{ label: t('selectState'), value: '' }, ...statesIN] : []
            }
          })}
        />
      }
      {
        state.showUpload &&
        <UploadModal
          modelTitle={t('pages.pagesContent.distributors.uploadBtn')}
          onUploadClose={onUploadClose}
          onDownloadSampleFile={onDownloadSampleFile}
          uploadedFile = { uploadedFile }
          onUploadFileChangeHandler = { (e) => onUploadFileChangeHandler(e) }
          uploadFileStatusBlock = { uploadFileStatusBlock }
        />
      }
       {
               !ready &&<div className='overlay_hide sub'></div>
                }
    </div>
  )
}